export default class EventSet {
  constructor(eventHandlers) {
    this.handlers = new Set(eventHandlers);
  }

  addHandlers(eventHandlers) {
    const handlerSet = new Set(this.handlers);

    eventHandlers.forEach(eventHandler => {
      // We should delete a handler from the set, otherwise it will be not the last element in the
      // set.
      handlerSet.delete(eventHandler);
      handlerSet.add(eventHandler);
    });

    return new EventSet(handlerSet);
  }

  dispatchEvent(event, dispatchAll) {
    if (dispatchAll) {
      this.handlers.forEach(handler => {
        handler(event);
      });
      return;
    }

    const recentHandler = [...this.handlers].pop();

    recentHandler(event);
  }

  hasHandlers() {
    return this.handlers.size > 0;
  }

  removeHandlers(eventHandlers) {
    const handlerSet = new Set(this.handlers);

    eventHandlers.forEach(eventHandler => {
      handlerSet.delete(eventHandler);
    });

    return new EventSet(handlerSet);
  }
}
